var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircledCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 2.66659C5.0544 2.66659 2.66659 5.0544 2.66659 7.99992C2.66659 10.9454 5.0544 13.3333 7.99992 13.3333C10.9454 13.3333 13.3333 10.9454 13.3333 7.99992C13.3333 5.0544 10.9454 2.66659 7.99992 2.66659ZM1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992Z",
    fill: "#FC5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52851 5.52851C5.78886 5.26816 6.21097 5.26816 6.47132 5.52851L7.99992 7.05711L9.52851 5.52851C9.78886 5.26816 10.211 5.26816 10.4713 5.52851C10.7317 5.78886 10.7317 6.21097 10.4713 6.47132L8.94273 7.99992L10.4713 9.52851C10.7317 9.78886 10.7317 10.211 10.4713 10.4713C10.211 10.7317 9.78886 10.7317 9.52851 10.4713L7.99992 8.94273L6.47132 10.4713C6.21097 10.7317 5.78886 10.7317 5.52851 10.4713C5.26816 10.211 5.26816 9.78886 5.52851 9.52851L7.05711 7.99992L5.52851 6.47132C5.26816 6.21097 5.26816 5.78886 5.52851 5.52851Z",
    fill: "#FC5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledCross);
export default __webpack_public_path__ + "static/media/circled-cross.f40788b8.svg";
export { ForwardRef as ReactComponent };